import axios from "axios"
const instance = axios.create({
	baseURL: "https://api2.cms.riesun.cn/api",
	timeout: 30000,
	headers: {
		'Authorization': '123456',
		'tenant': '663146',
	},
	
})

instance.interceptors.request.use((config) => {
	return config;
})
instance.interceptors.response.use((response) => {
	return Promise.resolve(response.data)
})

export default instance;